module.exports = __webpack_public_path__ + "img/perks-coming-soon-2.0caa8422.png";